import React from "react";

import { IconName, Region } from "../types";
import Icon from "./Icon";
import Select, { SelectOption } from "./Select";

const LandFilters = (props: {
  suburbs: Region[];
  houseSizes: string[];
  suburb: string;
  estate: string;
  minMetres: string;
  maxMetres: string;
  onChangeSuburb: (val: string) => void;
  onChangeEstate: (val: string) => void;
  onChangeMinMetres: (val: string) => void;
  onChangeMaxMetres: (val: string) => void;
  onReset: () => void;
  onSearch?: () => void;
}) => {
  const getRegionOptions = () => {
    const options = [{ key: "", value: "Suburb" }];
    for (const region of props.suburbs) {
      options.push({
        key: region.id,
        value: region.title,
      });
    }
    return options;
  };

  const getEstateOptions = () => {
    const options = [{ key: "", value: "Estate" }];

    if (props.suburb !== "") {
      for (const region of props.suburbs) {
        if (region.id === props.suburb) {
          for (const estate of region.estates) {
            options.push({
              key: estate.id,
              value: estate.title,
            });
          }
          break;
        }
      }
    }
    options.push({ key: "other", value: "Other" });
    return options;
  };

  const getMinOptions = () => {
    const options: SelectOption[] = [
      {
        key: "",
        value: "Minimum",
      },
    ];
    for (const i of props.houseSizes) {
      options.push({
        key: i,
        value: parseInt(i).toLocaleString(),
      });
    }
    return options;
  };

  const getMaxOptions = () => {
    const options: SelectOption[] = [
      {
        key: "",
        value: "Maximum",
      },
    ];
    for (const i of props.houseSizes) {
      options.push({
        key: i,
        value: parseInt(i).toLocaleString(),
      });
    }
    return options;
  };

  return (
    <div className={"pyht-land-filters"}>
      <div className={"filter-section location"}>
        <span className={"filters-label"}>Location</span>
        <div className={"select-container"}>
          <div className={"select"}>
            <Select
              id={"land-filters-suburb"}
              options={getRegionOptions()}
              value={props.suburb}
              onChange={(val) => props.onChangeSuburb(val)}
            />
          </div>
          <div className={"select"}>
            <Select
              id={"land-filters-estate"}
              options={getEstateOptions()}
              value={props.estate}
              onChange={(val) => props.onChangeEstate(val)}
            />
          </div>
        </div>
      </div>

      <div className={"filter-section location"}>
        <span className={"filters-label"}>House Size (M&sup2;)</span>
        <div className={"select-container"}>
          <div className={"select"}>
            <Select
              id={"land-filters-size-min"}
              options={getMinOptions()}
              value={props.minMetres}
              onChange={(val) => props.onChangeMinMetres(val)}
            />
          </div>
          <div className={"select"}>
            <Select
              id={"land-filters-size-max"}
              options={getMaxOptions()}
              value={props.maxMetres}
              onChange={(val) => props.onChangeMaxMetres(val)}
            />
          </div>
        </div>
      </div>
      <div className={"search-section"}>
        <button
          className={"btn search-btn"}
          onClick={() => props.onSearch && props.onSearch()}
        >
          Search
        </button>
      </div>
      <div className={"reset-section"}>
        <div
          role={"button"}
          className={"reset-btn"}
          onClick={() => props.onReset()}
        >
          <span className={"filters-label"}>Reset Filter Options</span>
          <Icon name={IconName.UNDO} />
        </div>
      </div>
    </div>
  );
};

export default LandFilters;
